import React from 'react';

type StatusVariant =
  | 'active' | 'planned' | 'completed' | 'closed' | 'transferred' | 'sold'
  | 'available'| 'occupied' | 'cleaning' | 'maintenance' | 'inactive' |'scheduled'| 'due' | 'overdue' | 'missed' |'in-stock'| 'low' | 'critical' | 'out-of-stock' |'pending'| 'approved' | 'rejected' | 'in-progress' | 'cancelled' |'broiler'| 'layer' | 'breeder' | 'local' |'trial' | 'expired' | 'suspended'
  | string;

interface StatusBadgeProps {
  status: StatusVariant;
  size?: 'sm' | 'md';
  dot?: boolean;
}

const STATUS_CONFIG: Record<string, { bg: string; color: string; label?: string }> = {
  active:        { bg: '#f0fdf4', color: '#15803d' },
  planned:       { bg: '#eff6ff', color: '#2563eb' },
  completed:     { bg: '#f1f5f9', color: '#475569' },
  closed:        { bg: '#f1f5f9', color: '#64748b' },
  transferred:   { bg: '#faf5ff', color: '#7c3aed' },
  sold:          { bg: '#fff7ed', color: '#c2410c' },
  available:     { bg: '#f0fdf4', color: '#15803d' },
  occupied:      { bg: '#eff6ff', color: '#2563eb' },
  cleaning:      { bg: '#fff7ed', color: '#c2410c' },
  maintenance:   { bg: '#fffbeb', color: '#d97706' },
  inactive:      { bg: '#f1f5f9', color: '#94a3b8' },
  scheduled:     { bg: '#eff6ff', color: '#2563eb' },
  due:           { bg: '#fffbeb', color: '#d97706' },
  overdue:       { bg: '#fef2f2', color: '#dc2626' },
  missed:        { bg: '#fef2f2', color: '#dc2626' },
  'in-stock':    { bg: '#f0fdf4', color: '#15803d', label: 'In Stock' },
  low:           { bg: '#fffbeb', color: '#d97706', label: 'Low Stock' },
  critical:      { bg: '#fff1f2', color: '#e11d48', label: 'Critical' },
  'out-of-stock':{ bg: '#fef2f2', color: '#dc2626', label: 'Out of Stock' },
  pending:       { bg: '#fffbeb', color: '#d97706' },
  approved:      { bg: '#f0fdf4', color: '#15803d' },
  rejected:      { bg: '#fef2f2', color: '#dc2626' },
  'in-progress': { bg: '#eff6ff', color: '#2563eb', label: 'In Progress' },
  cancelled:     { bg: '#f1f5f9', color: '#64748b' },
  broiler:       { bg: '#fff7ed', color: '#c2410c' },
  layer:         { bg: '#faf5ff', color: '#7c3aed' },
  breeder:       { bg: '#eff6ff', color: '#2563eb' },
  local:         { bg: '#f0fdf4', color: '#15803d' },
  trial:         { bg: '#fffbeb', color: '#d97706' },
  expired:       { bg: '#fef2f2', color: '#dc2626' },
  suspended:     { bg: '#fef2f2', color: '#dc2626' },
};

export default function StatusBadge({ status, size = 'md', dot = false }: StatusBadgeProps) {
  const config = STATUS_CONFIG[status.toLowerCase()] ?? { bg: '#f1f5f9', color: '#64748b' };
  const label = config.label ?? (status.charAt(0).toUpperCase() + status.slice(1).replace(/-/g, ' '));

  return (
    <span
      className="status-badge"
      style={{
        backgroundColor: config.bg,
        color: config.color,
        fontSize: size === 'sm' ? '0.625rem' : '0.6875rem',
        padding: size === 'sm' ? '0.1rem 0.375rem' : '0.125rem 0.5rem',
      }}
    >
      {dot && (
        <span
          className="inline-block w-1.5 h-1.5 rounded-full mr-1.5 flex-shrink-0"
          style={{ backgroundColor: config.color }}
        />
      )}
      {label}
    </span>
  );
}